import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { ReportProvider } from '../../providers/report/report';
import { GlobalVars } from '../../app/app.environment';
import { UserProvider } from '../../providers/user/user';
import { Role } from '../../models/roles';


@IonicPage()
@Component({
  selector: 'page-report-user',
  templateUrl: 'report-user.html',
})
export class ReportUserPage {

  users;
  beginMonth;
  endMonth;
  isAdmin: boolean;
  relativeTime: boolean = false;
  selectedUser;

  constructor(
    public loadingCtrl: LoadingController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public globalVars: GlobalVars,
    public reportProvider: ReportProvider,
    public userProvider: UserProvider
  ) {
    this.isAdmin = this.globalVars.user.role == Role['admin'];
    this.users = userProvider.getUserNames();
    
    let now = new Date()
    let month = new Date(now.getFullYear(), now.getMonth(), 1, 2, 0, 0, 0)
    month.setMinutes(month.getMinutes() - new Date().getTimezoneOffset())

    this.beginMonth = month.toISOString();
    this.endMonth = month.toISOString();
  }

  generate() {
    if(this.beginMonth && this.endMonth) {
      let loading = this.loadingCtrl.create();
      loading.present();

      this.reportProvider.userReport(this.beginMonth, this.endMonth, this.selectedUser || this.globalVars.user, this.relativeTime)
        .then(() => loading.dismiss())
        .catch(error => loading.dismiss())
    }
    else this.showMessage('Introduzca todos los datos.');
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/report-user/report-user.ts